import { recentUsersParser } from 'shared/parsers';

import {
  GET_RECENT_USERS,
  GET_RECENT_USERS_SUCCESS,
  GET_RECENT_USERS_ERROR,
} from './recentUsersActions';

const initialState = {
  isPending: false,
  total: 0,
  data: [],
};

export function recentUsers(state = initialState, action) {
  const { response, type } = action;

  switch (type) {
    case GET_RECENT_USERS:
      return { ...state, isPending: true };
    case GET_RECENT_USERS_SUCCESS:
      return { isPending: false, data: recentUsersParser(response.data), total: response.total };
    case GET_RECENT_USERS_ERROR:
      return { ...state, isPending: false };
    default:
      return state;
  }
}
